import { render } from "./IconStarBorder.vue?vue&type=template&id=71590647"
import script from "./IconStarBorder.vue?vue&type=script&lang=js"
export * from "./IconStarBorder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__